import React from "react";
import { AxiosError } from "axios";
import getErrorMessage from "../../../helpers/getErrorMessage";

interface ErrorProps {
  error: string | AxiosError | null;
}

const Error: React.FC<ErrorProps> = ({ error }) => {
  const message = getErrorMessage(error);

  return message ? (
    <div className="alert alert-danger" role="alert">
      {message}
    </div>
  ) : null;
};

export default Error;
